import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "mapContainer",
  class: "w-screen z-0 h-full"
}

import { harborPopUp } from "@/classes/BaseMap"
import { store } from "@/main"
import { watch } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseMap',
  setup(__props) {

watch(() => store.getData().dataLoaded, () => {
  if (store.getData().dataLoaded) store.displayMap()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(harborPopUp).visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "customPopUp",
          style: _normalizeStyle({ left: _unref(harborPopUp).coordinates.x + 'px', top: _unref(harborPopUp).coordinates.y + 'px' })
        }, _toDisplayString(_unref(harborPopUp).content), 5))
      : _createCommentVNode("", true)
  ]))
}
}

})